import "./App.css";
import { Route, Routes } from "react-router-dom";
import Main from "./Main";
import LoginPage from "./pages/LoginPage";
import JoinPage from "pages/JoinPage";
import VerifyEmailPage from "pages/VerifyEmailPage";
import WithdrawPage from "pages/WithdrawPage";
import FindIdPage from "pages/FindIdPage";
import FindPasswordPage from "pages/FindPasswordPage";
import ResetPasswordPage from "pages/ResetPasswordPage";
import { useEffect, useRef, useState } from "react";
import { useAppContext } from "utils/store";
import { connectLoginWebSocket } from "websock/loginManager";
import UserAccountPage from "pages/UserAccountPage";

function App() {
  const {
    store: { id },
  } = useAppContext();

  useEffect(() => {
    connectLoginWebSocket(id, (data) => {
      console.log(data);
    });
  }, [id]);

  return (
    <>
      <Routes>
        <Route path="join" element={<JoinPage />} />
        <Route
          path="verify-email/:uidb64/:token/"
          element={<VerifyEmailPage />}
        />
        <Route path="withdraw" element={<WithdrawPage />} />
        <Route path="find-id" element={<FindIdPage />} />
        <Route path="find-password" element={<FindPasswordPage />} />
        <Route
          path="reset-password/:uidb64/:token/"
          element={<ResetPasswordPage />}
        />
        <Route path="user-account" element={<UserAccountPage />} />
        <Route path="/" element={<LoginPage />} />
        <Route path="*" element={<Main />} />
      </Routes>
    </>
  );
}

export default App;
